var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - import",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1683",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8223"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2840",
    d: "M42.7 9.578a.5.5 0 0 0 .354.151h.005a.5.5 0 0 0 .353-.144l9.874-9.876a.506.506 0 0 0 0-.7.5.5 0 0 0-.354-.151h-.006a.5.5 0 0 0-.351.142L42.7 8.874a.506.506 0 0 0 0 .704z",
    transform: "translate(-36.494 4.273)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2841",
    d: "M12.214 3.613a.508.508 0 0 0-.507.507v6.856a.779.779 0 0 1-.778.778H.643a.779.779 0 0 1-.778-.778V.692a.779.779 0 0 1 .778-.778H7.5a.508.508 0 0 0 .507-.507A.508.508 0 0 0 7.5-1.1H.643A1.8 1.8 0 0 0-1.15.692v10.285A1.8 1.8 0 0 0 .643 12.77h10.285a1.8 1.8 0 0 0 1.793-1.793V4.12a.508.508 0 0 0-.507-.507z",
    transform: "translate(4.214 4.23)",
    style: {
      fill: "currentColor"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bae892771b48f4b8b6b7efedbbad9d6a.svg";
export { ForwardRef as ReactComponent };